import * as React from "react";

import Image from "next/image";

import A from "../../../public/assets/icons/grades/A.png";
import B from "../../../public/assets/icons/grades/B.png";
import C from "../../../public/assets/icons/grades/C.png";
import D from "../../../public/assets/icons/grades/D.png";
import E from "../../../public/assets/icons/grades/E.png";

const grades = { A, B, C, D, E };

const Grades = ({ grade }) => {
  return (
    <>
      {grades[grade] ? (
        <Image
          src={grades[grade]}
          placeholder="blur"
          layout="responsive"
          width={1}
          height={1}
          alt={grade}
        />
      ) : (
        grade
      )}
    </>
  );
};

export default Grades;
